import { render } from "./RuiAdd.vue?vue&type=template&id=456d47a2"
const script = {}
script.render = render

export default script